const NETWORK_ERROR_PATTERNS = [
  /network\s*error/i,
  /request timed out/i,
  /socket is closed/i,
  /could not load data\. please check your internet connection/i,
  /no response text available/i,
  // expo/fetch passes the platform's own message through (iOS NSURLError,
  // Android java.net exceptions).
  /network connection was lost/i,
  /internet connection appears to be offline/i,
  /could not connect to the server/i,
  /UnknownHostException|ConnectException/,
];

export const getErrorMessage = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return [value.name, value.message, value.toString?.()]
    .filter(Boolean)
    .join(": ");
};

export const isRecoverableNetworkError = (error) => {
  const message = getErrorMessage(error);
  return NETWORK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export const hasConcreteRequestContext = (event = {}) => {
  const request = event.request || {};
  const extra = event.extra || {};
  return Boolean(
    request.url ||
      request.method ||
      extra.url ||
      extra.requestData ||
      extra.status ||
      extra.statusCode
  );
};
